import { ServiceType } from ".";
import { WithI18n } from "../../i18n";

export enum ServiceTypeListItemType {
  SERVICE,
  PRODUCT,
}

export interface ServiceTypeListItemService {
  id: string;
  name: string;
  providedBy: {
    id: string;
    name: string;
  };
  type: ServiceType;
}

export interface ServiceTypeListItemTargetApartment {
  id: string;
  code: string;
  building: {
    id: string;
    code: string;
  };
}

type ServiceTypeListItemI18n = WithI18n<
  "notes" | "label" | "description" | "prefix" | "suffix"
> &
  WithI18n<"categories", string[]>;

export interface ServiceTypeListItem extends ServiceTypeListItemI18n {
  id?: string;
  service: ServiceTypeListItemService;
  categories?: string[];
  notes?: string;
  label?: string;
  description?: string;
  imageUrl?: string;
  price?: number;
  inPromo?: boolean;
  promoPrice?: number;
  type: ServiceTypeListItemType;
  requiredTime?: number;
  order?: number;
  targetApartment?: ServiceTypeListItemTargetApartment;
  minSellableQuantity?: number;
  maxSellableQuantity?: number;
}
